import AIMarker from 'components/elements/AIMarker';
import FilterDropdown from 'components/elements/Dropdown/FilterDropdown';
import { FlexRow } from 'components/layout/FlexRow';
import { useWorkTypes, useWorkTypesExclusions } from 'state/dashboard';
import { WORK_TYPE_OPTIONS } from 'utils/constants/workTypes';

const titleStyle = {
  columnGap: 'padding_4',
};

const WorkTypeFilter = () => {
  const [workTypes, setWorkTypes] = useWorkTypes();
  const [workTypesExclusions, setWorkTypesExclusions] = useWorkTypesExclusions();

  const handleClearAll = () => {
    setWorkTypes([]);
    setWorkTypesExclusions([]);
  };

  const handleClearAllExclusions = () => {
    setWorkTypesExclusions([]);
  };

  return (
    <FilterDropdown
      options={WORK_TYPE_OPTIONS}
      onClearAll={handleClearAll}
      checkedValues={workTypes}
      setCheckedValues={setWorkTypes}
      description="The scope of work involved in the project"
      isExclusion
      setExclusionValues={setWorkTypesExclusions}
      exclusionValues={workTypesExclusions}
      onExclusionClearAll={handleClearAllExclusions}
    >
      <FlexRow sx={titleStyle}>
        Work Type <AIMarker />
      </FlexRow>
    </FilterDropdown>
  );
};

export default WorkTypeFilter;
